/* eslint no-inline-comments: 0 */

const List = () => import( /* webpackChunkName: "group-job-functions" */ `./list.vue` );
const Add = () => import( /* webpackChunkName: "group-job-functions" */ `./add.vue` );
const Edit = () => import( /* webpackChunkName: "group-job-functions" */ `./edit.vue` );

export default {
	path: `job-functions`,
	children: [
		{
			path: ``,
			name: `list-job-functions`,
			component: List,
			meta: {
				title: `Job Functions`
			}
		},
		{
			path: `new`,
			name: `add-job-functions`,
			component: Add,
			meta: {
				title: `Add Job Function`
			}
		},
		{
			path: `:uuid`,
			name: `edit-job-functions`,
			component: Edit,
			meta: {
				title: `Edit Job Function`
			}
		}
	]
};
